module.exports = __webpack_public_path__ + "static/Activity_app_screen-7e4edd9cfc4f268a1dd8d0e3591e7972.png";